// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports

export default function ExpansionHeaderRow() {
   const state = useQuoteContext()
   const { getString } = state

   return (
      <div className='row'>
         <h5 className='col-bhr1'>
            {getString('product.ExpansionHeaderRow.Header.Title')}
         </h5>
         <h5 className='col-bhr2'>{getString('global.Qty')}</h5>
         <h5 className='col'>&nbsp;</h5>
         <div className='col'>&nbsp;</div>
         <h5 className='col'>&nbsp;</h5>
         <h5 className='col'>{getString('global.Final')}</h5>
         {state.differenceQuote == true ? (
            <>
               <div className='col'></div>
               <div className='col'></div>
            </>
         ) : (
            <></>
         )}
      </div>
   )
}
